import { useKeyModifier, useEventListener } from '@vueuse/core';
import { watch } from 'vue';

export const dragToScroll = (ElementRef) => {
  let mouseDown = false;
  let startX, scrollLeft;

  const altState = useKeyModifier('Alt');
  watch(altState, (newVal) => {
    if (newVal) {
      ElementRef.value.classList.add('is-dragging');
    } else {
      ElementRef.value.classList.remove('is-dragging');
    }
  });

  useEventListener(ElementRef, 'mousemove', (e) => {
    e.preventDefault();
    if (!mouseDown || !e.altKey) {
      return;
    }
    const x = e.pageX - ElementRef.value.offsetLeft;
    const scroll = x - startX;
    ElementRef.value.scrollLeft = scrollLeft - scroll;
  });

  useEventListener(ElementRef, 'mousedown', (e) => {
    if (e.altKey) {
      mouseDown = true;
      startX = e.pageX - ElementRef.value.offsetLeft;
      scrollLeft = ElementRef.value.scrollLeft;
    }
  });

  useEventListener(ElementRef, 'mouseup', () => {
    mouseDown = false;
    ElementRef.value.classList.remove('is-dragging');
  });

  useEventListener(ElementRef, 'mouseleave', () => {
    mouseDown = false;
    ElementRef.value.classList.remove('is-dragging');
  });
};
